import { Component, OnInit } from '@angular/core';



@Component({
  selector: 'app-request-manage',
  templateUrl: './disclaimer.component.html'
})
export class disclaimerComponent implements OnInit {
	
	constructor() { }

  ngOnInit() {
	 
  }
  
 

}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/components/disclaimer/disclaimer.component.ts